import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, PLATFORM_ID, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { interval } from 'rxjs';

@Component({
  selector: 'sd-cart-totals-coupon-loader',
  standalone: true,
  templateUrl: './cart-totals-coupon-loader.component.html',
  styleUrls: ['./cart-totals-coupon-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartTotalsCouponLoaderComponent {
  private platformId = inject(PLATFORM_ID);
  protected activeIndex = signal<number>(0);

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      interval(500)
        .pipe(takeUntilDestroyed())
        .subscribe(() => {
          this.activeIndex.update((index) => (index + 1) % 3);
        });
    }
  }
}
